import { render, staticRenderFns } from "./TodosOsDados.vue?vue&type=template&id=8a0038f0&scoped=true"
import script from "./TodosOsDados.vue?vue&type=script&lang=js"
export * from "./TodosOsDados.vue?vue&type=script&lang=js"
import style1 from "./TodosOsDados.vue?vue&type=style&index=1&id=8a0038f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0038f0",
  null
  
)

export default component.exports